import React from 'react';
import { string, number, bool, array, object, shape, oneOfType, node, func } from 'prop-types';
import classNames from 'classnames';
import GigCardCarousel from '@fiverr-private/gig_listings/src/entries/GigCardCarousel';
import { SLIDER_BREAKPOINTS } from '../../../utils/slider/constants';
import contextEnrichment from '../../../utils/contextEnrichment';

import './style.scss';

const SLIDER_BASE_NUM = 5;

const GigCarouselWrapper = ({
    boxSubTitle,
    boxClass,
    carouselPosition,
    isTouch = false,
    boxTitle,
    page_ctx_id,
    currency,
    gigs,
    isLoading,
    gigCollect
}) => {
    const contextEnrichmentProps = {
        carouselPosition,
        isTouch,
        currency,
        page_ctx_id,
        boxClass,
        gigCollect
    };

    const enrichedContext = contextEnrichment({...contextEnrichmentProps});
    const boxClasses = classNames('recommendations-carousel', boxClass);

    return (
        <div className={boxClasses}>
            <header>
                <h2>{boxTitle}</h2>
                {
                    boxSubTitle && <small>{boxSubTitle}</small>
                }
            </header>
            <GigCardCarousel sliderBaseNum={SLIDER_BASE_NUM} sliderBreakpoints={SLIDER_BREAKPOINTS}
                gigs={gigs} {...{...enrichedContext}} isLoading={isLoading} isInfinite={true}/>
        </div>
    );
};

GigCarouselWrapper.propTypes = {
    gigs: array,
    boxClass: string,
    boxTitle: oneOfType([
        node,
        func
    ]),
    boxSubTitle: string,
    carouselPosition: number,
    page_ctx_id: string,
    isTouch: bool,
    isLoading: bool,
    gigCollect: object,
    currency: shape({
        name: string,
        rate: number,
        template: string,
        forceRound: bool,
        forceRoundFromAmount: number
    })
};

export default GigCarouselWrapper;
